/*
 * UpgradeQualification Messages
 *
 * This contains all the text for the UpgradeQualification component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'components.QualificationDetails';

export default defineMessages({
  test: {
    id: `${scope}.test`,
    defaultMessage: 'Test',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel',
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: 'Save',
  },
  level: {
    id: `${scope}.level`,
    defaultMessage: 'Level',
  },
  tester: {
    id: `${scope}.tester`,
    defaultMessage: 'Authorized Tester',
  },
  instructor: {
    id: `${scope}.instructor`,
    defaultMessage: 'Instructor',
  },
});
